class Site {
  constructor() {
    this.initElements();
  }

  initElements() {
    // Carrosséis que usam Swiper agora inicializam no próprio componente React
    // (ex.: EmFocoCarousel em CapaView).
  }
}

new Site();
